import script from "./MedicineSelectorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MedicineSelectorModal.vue?vue&type=script&setup=true&lang=js"

import "./MedicineSelectorModal.vue?vue&type=style&index=0&id=f766496a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f766496a"]])

export default __exports__